import * as React from "react";
const IconBackArrow = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.9867 11.9925C21.9867 12.1914 21.9077 12.3822 21.767 12.5228C21.6264 12.6635 21.4356 12.7425 21.2367 12.7425H6.54699L12.0173 18.2119C12.087 18.2815 12.1423 18.3643 12.18 18.4553C12.2177 18.5464 12.2371 18.6439 12.2371 18.7425C12.2371 18.841 12.2177 18.9386 12.18 19.0297C12.1423 19.1207 12.087 19.2034 12.0173 19.2731C11.9476 19.3428 11.8649 19.3981 11.7738 19.4358C11.6828 19.4735 11.5852 19.4929 11.4867 19.4929C11.3881 19.4929 11.2905 19.4735 11.1995 19.4358C11.1085 19.3981 11.0257 19.3428 10.956 19.2731L4.20605 12.5231C4.13632 12.4535 4.081 12.3707 4.04325 12.2797C4.00551 12.1886 3.98608 12.091 3.98608 11.9925C3.98608 11.8939 4.00551 11.7963 4.04325 11.7053C4.081 11.6142 4.13632 11.5315 4.20605 11.4619L10.956 4.71186C11.0968 4.57113 11.2877 4.49207 11.4867 4.49207C11.6857 4.49207 11.8766 4.57113 12.0173 4.71186C12.158 4.85259 12.2371 5.04346 12.2371 5.24248C12.2371 5.44151 12.158 5.63238 12.0173 5.77311L6.54699 11.2425H21.2367C21.4356 11.2425 21.6264 11.3215 21.767 11.4622C21.9077 11.6028 21.9867 11.7936 21.9867 11.9925Z"
      fill="#1C1C2C"
    />
  </svg>
);
export default IconBackArrow;
